import { useQueryPlaceNodes } from 'src/features/tanStackQuery/commonQueries/useQueryPlaceNodes'
import { useQueryUserPlaceNodes } from 'src/features/tanStackQuery/commonQueries/useQueryUserPlaceNodes'

/**
 * 実施状況の絞り込みで選択できる現場を取得する。
 *
 * 現場に未所属のユーザーはすべての現場に所属しているのと同じ扱いとなるため、その場合は全現場を返す。
 */
export const useSelectablePlaceNodes = () => {
  const userPlaceNodesQuery = useQueryUserPlaceNodes()
  const allPlaceNodesQuery = useQueryPlaceNodes()

  const isPending =
    userPlaceNodesQuery.isPending || allPlaceNodesQuery.isPending
  const isError = userPlaceNodesQuery.isError || allPlaceNodesQuery.isError

  if (isPending || isError) {
    return { isError, isPending, placeNodes: [] }
  }

  const userHasSomeAssignedPlaceNodes = userPlaceNodesQuery.data.length > 0

  return {
    isError,
    isPending,
    placeNodes: userHasSomeAssignedPlaceNodes
      ? userPlaceNodesQuery.data
      : allPlaceNodesQuery.data,
  }
}
